import { render, staticRenderFns } from "./ModalHistoricoCertificado.vue?vue&type=template&id=2d1fa223&"
import script from "./ModalHistoricoCertificado.vue?vue&type=script&lang=js&"
export * from "./ModalHistoricoCertificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports